// Distances in metres, independent of latitude and the map's zoom.
const EARTH_RADIUS = 6371008.8;
const radians = (degrees) => degrees * Math.PI / 180;
const degrees = (angle) => angle * 180 / Math.PI;

export const defaultRadarRange = (node) => node?.aerial ? 20000 : 3000;

function destination(coords, bearing, distance) {
 const [lon, lat] = coords.map(radians), angle = radians(bearing), arc = distance / EARTH_RADIUS;
 const targetLat = Math.asin(Math.sin(lat)*Math.cos(arc) + Math.cos(lat)*Math.sin(arc)*Math.cos(angle));
 const targetLon = lon + Math.atan2(Math.sin(angle)*Math.sin(arc)*Math.cos(lat), Math.cos(arc)-Math.sin(lat)*Math.sin(targetLat));
 return [((degrees(targetLon)+540)%360)-180, degrees(targetLat)];
}

export function radarGeometry(coords, bearing, fov, distance) {
 const halfFov = Math.min(70, Math.max(1, fov/2));
 const arc = Array.from({length:41}, (_,step) => destination(coords, bearing-halfFov+step*halfFov/20, distance));
 return {type:'FeatureCollection',features:[
  {type:'Feature',properties:{},geometry:{type:'Polygon',coordinates:[[coords,...arc,coords]]}},
  {type:'Feature',properties:{},geometry:{type:'LineString',coordinates:[coords,destination(coords,bearing,distance)]}},
 ]};
}
